import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Label from "theme/components/atoms/Form/Label";

const Item = ({
  label,
  children,
  appearance,
  required,
  name,
  labelSrOnly = false,
}) => {
  required =
    typeof required === "undefined" && React.isValidElement(children)
      ? children.props.required
      : required;

  name =
    typeof name === "undefined" && React.isValidElement(children)
      ? children.props.id || children.props.name
      : name;

  const classes = classNames({
    [`form-item`]: true,
    [`form-item--${appearance}`]: appearance,
    required,
  });

  if (process.env.NODE_ENV === "development" && !label && label !== null) {
    console.warn(
      "A FormItem should have a label. If you are sure about not setting it, please set value `null` for property `label`."
    );
  }

  return (
    <div className={classes}>
      {label && (
        <div
          className={classNames("form-item__label", {
            "form-item__label--sr-only": labelSrOnly,
          })}
        >
          <Label required={required} htmlFor={name} srOnly={labelSrOnly}>
            {label}
          </Label>
        </div>
      )}
      <div className="form-item__input">{children}</div>
    </div>
  );
};

Item.propTypes = {
  label: PropTypes.node,
  children: PropTypes.node.isRequired,
  appearance: PropTypes.oneOf([
    "default",
    "inline",
    "double",
    "checkout-ref",
    "checkbox",
  ]),
  required: PropTypes.bool,
  name: PropTypes.string,
};

export default Item;
